import { Tooltip } from "@material-ui/core";
import { memo } from "react";

import MarkerArchiveCabinet from "@/assets/img/map/MarkerArchiveCabinet.svg";
import { useStyles } from "@/common/components/MapLandingPage/Map/ArchiveCabinetMarker/ArchiveCabinetMarkerStyles";

import { MarkerProps } from "../types";


const ArchiveCabinetMarker: React.FC<MarkerProps> = ({ lat, lng, text, unitId, onClick }) => {
    const classes = useStyles();

    return (
        <Tooltip title={text} classes={{ popper: classes.tooltip }}>
            <div className={classes.marker} onClick={() => onClick({ unitId, lat, lng, text, isCabinet: true })}>
                <img src={MarkerArchiveCabinet} alt="Archive Cabinet" />
            </div>
        </Tooltip>
    );
};

export default memo(ArchiveCabinetMarker);
